import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IGroupRepository } from '@/coreInfrastructureModule/interfaces/IGroupRepository';
import { PostGroupAdapter } from '../adapter/postGroupAdapter';

/**
 * グループを新たに作成するUseCase
 */
export class CreateGroupUseCase {
  /**
   * グループを新たに作成する モック関数
   * @param repository - リポジトリ
   * @param groupName - グループ名
   */
  public ExecuteMock = async (repository: IGroupRepository, groupName: string): Promise<INetworkResult<void, Error>> => {
    try {
      const request = PostGroupAdapter.adaptForRequest(groupName);
      const result = await repository.postGroup(request);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('作成に失敗しました'),
        },
      };
    }
  };
}
